export const TAG_TYPE_CAMPAIGN = 'campaigns';
export const TAG_TYPE_HOLIDAY = 'holiday-types';

export const TAGS_TYPES = [TAG_TYPE_CAMPAIGN, TAG_TYPE_HOLIDAY] as const;

export type TagType = (typeof TAGS_TYPES)[number];
